import { AdminRoles, AdminRoleOptions } from 'admin/constants/AdminRoles';
import BoxBody from 'components/BoxBody.jsx';
import Button from 'components/Button.jsx';
import { capitalize } from 'lodash';
import DialogContent from 'components/DialogContent.jsx';
import Form from 'components/Form.jsx';
import FormInput from 'components/FormInput.jsx';
import FormSelect from 'components/FormSelect.jsx';
import Label from 'components/Label.jsx';
import Radio from 'components/Radio.jsx';
import React from 'react';
import RequireUser from 'components/mixins/RequireUser';
import RoleVerificationActions from 'actions/RoleVerificationActions';
import RoleVerificationStore from 'stores/RoleVerificationStore';
import SchoolPicker from 'components/SchoolPicker.jsx';
import { OrganizationTypes as ORGS } from 'constants/OrganizationConstants';

import './styles/SetupAdmin.scss';

const EVENT_SCREEN_NAME = 'SetupAdminRoles';

const SetupAdmin = React.createClass({
  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  childContextTypes: {
    eventScreenName: React.PropTypes.string,
  },

  mixins: [
    RequireUser,
  ],

  getInitialState() {
    const existingVerificationState = {};
    const roleVerification = RoleVerificationStore.getRoleVerification();
    if (roleVerification) {
      existingVerificationState.isSchool = roleVerification.is_school;
      existingVerificationState.organizationId = roleVerification.organization_id;

      const currentRole = roleVerification.role;
      if (currentRole in AdminRoles) {
        existingVerificationState.role = currentRole;
      } else {
        existingVerificationState.role = 'other';
        existingVerificationState.otherRole = currentRole;
      }
    }
    return Object.assign({
      enabled: false,
      isSchool: true,
    }, existingVerificationState);
  },

  getChildContext() {
    return {
      eventScreenName: EVENT_SCREEN_NAME,
    };
  },

  onSelectOrg(organizationId) {
    this.setState({ enabled: true, organizationId });
  },

  submit(attrs) {
    const roleVerification = {
      organization_id: this.state.organizationId,
      is_school: this.state.isSchool,
    };

    roleVerification.role = (this.state.role === 'other')
      ? attrs.other_role : attrs.role;

    RoleVerificationActions.addRoleVerification(roleVerification);
    this.context.router.push('/setup/school_email');
  },

  roleSelected() {
    if (this.state.role) {
      if (this.state.role === 'other') {
        return !!this.state.otherRole;
      } else {
        return true;
      }
    } else {
      return false;
    }
  },

  renderOtherRole() {
    return (
      <div className="SetupAdmin-section">
        <FormInput
          label="Description"
          name={'other_role'}
          onChange={event => this.setState({ otherRole: event.target.value })}
          value={this.state.otherRole}
          placeholder="Describe your role"
        />
      </div>
    );
  },

  render() {
    const { isSchool, organizationId } = this.state;
    const organizationType = isSchool ? ORGS.SCHOOL : ORGS.DISTRICT;
    const organizationLabel = capitalize(organizationType.toLowerCase());

    return (
      <DialogContent
        size="small"
        full
        className="SetupAdmin"
        title={'Where do you work?'}
        subtext="We currently verify principals and assistant principals at US K-12 schools.
          If you’re an administrator in a different role, please send an email to
          schooladmin@remindhq.com and cc your principal for access to school features.">
        <BoxBody divided>
          <div>
            <Form onValidSubmit={this.submit}>
              <div className="SetupAdmin-section">
                <Label>Primary affiliation</Label>
                <div className="SetupAdmin-affiliation">
                  <Radio
                    className="SetupAdmin-affiliation-radio"
                    label="School"
                    onChange={() => this.setState({ isSchool: true })}
                    checked={isSchool}
                  />
                  <Radio
                    className="SetupAdmin-affiliation-radio"
                    label="District"
                    onChange={() => this.setState({ isSchool: false })}
                    checked={!isSchool}
                  />
                </div>
              </div>

              <div className="SetupAdmin-section">
                <Label>{organizationLabel}</Label>
                <SchoolPicker
                  organizationType={organizationType}
                  onSelect={this.onSelectOrg}
                  onClear={() => {}}
                  onCreateOrganization={(org) => this.onSelectOrg(org.id)}
                  schoolId={organizationId}
                  placeholder={`Search for your ${organizationLabel.toLowerCase()}`}
                  showNCESId
                />
              </div>

              <div className="SetupAdmin-section">
                <FormSelect
                  label={`Role at ${organizationLabel.toLowerCase()}`}
                  name="role"
                  searchable={false}
                  options={AdminRoleOptions}
                  onChange={role => this.setState({ role })}
                  value={this.state.role}
                />
              </div>

              {this.state.role === 'other' && this.renderOtherRole()}

              <Button
                disabled={!this.state.organizationId || !this.roleSelected()}
                className="SetupAdmin-Submit"
                type="submit"
                eventProperties={{
                  is_school: isSchool,
                }}
                eventElementName="SetupAdmin-Submit">
                Next
              </Button>
            </Form>
          </div>
        </BoxBody>
      </DialogContent>
    );
  },
});

export default SetupAdmin;



// WEBPACK FOOTER //
// ./src/setup/components/SetupAdminRole.jsx